
import { RootState } from "@/@types/store";
import { computed, defineComponent, ref, shallowRef, watch } from "vue";
import { FormDialog } from "@/components/Common";

import { useDialogCommon, useDialogFormData } from "@/hooks";
import { initFormData1 } from "./reAccountData";
import _ from "lodash";
import moment from "dayjs";

import { InitiateAdjustmentAccountBill } from "@/api-server/modules/defaultServer";

export default defineComponent({
  props: {
    visible: { type: Boolean, default: false },
    dealType: { type: Number, default: 2 },
    formData: {
      type: Object,
      default: () => ({ ...initFormData1 }),
    },
  },

  components: {
    FormDialog,
  },

  emits: ["update:visible", "updateSuccess"],

  setup(props, context) {
    const { visibleRef } = useDialogCommon(props, context);
    const dealTypeRef = ref<number>(props.dealType);
    const { editFormData } = useDialogFormData(
      props,
      { ...initFormData1 },
      {
        type: "resetWithPropsFormData",
        visiableRef: visibleRef,
      },
      (editFormDataRef) => {
        console.log(editFormDataRef);
      }
    );

    const rules = {
      expectValue: [
        { required: true, message: "请输入调账费用", trigger: "blur" },
        {
          pattern: /^-?([1-9]\d*\.?\d*|0\.\d*[1-9]\d*|0?\.0+|0)$/,
          message: "请输入正确的数字",
          trigger: "blur",
        },
      ],
    };

    async function saveFormHandle() {
      console.log("dealTypeRef===", dealTypeRef.value);
      const params = {
        contractProjectId: editFormData.value.contractProjectId,
        id: editFormData.value.id,
        siteId: editFormData.value.siteId,
        billCode: editFormData.value.billCode,
        remark: editFormData.value.remark,
        dealType: dealTypeRef.value,
        abnormalValueList: [
          {
            abnormalType: editFormData.value.dictCode || "6",
            expectValue: editFormData.value.fee + "",
          },
        ],
      };
      await InitiateAdjustmentAccountBill.fetch(params as any);
      visibleRef.value = false;
      context.emit("updateSuccess");
    }

    return {
      rules,
      visibleRef,
      dealTypeRef,
      editFormData,
      saveFormHandle,
    };
  },
});
